import { api } from "../config/api";
import { post } from "../api";

export interface NoticeBoardSessionArgs {
  business_id: string | number | null;
  device_token: string | null;
  session_id: string | null;
}

export interface GetBusinessNoticesResponse {
  success?: boolean;
  data?: { notices_info?: { notices?: unknown[] } };
  errors?: string;
}

export interface ClientGroupApiItem {
  is_active?: boolean;
  client_group_id: number | string;
  name: string;
  total_clients?: number;
}

export interface NoticeBoardGetBusinessClientGroupsResponse {
  success?: boolean;
  data?: { client_groups?: ClientGroupApiItem[] };
  errors?: string;
}

export interface NoticeClientApiItem {
  user?: { user_id: number | string };
  user_info?: { user_id: number | string };
  client_id?: number | string;
  user_id?: number | string;
  client_name?: string;
  full_name?: string;
  name?: string;
  first_name?: string;
  middle_name?: string;
  surname?: string;
  org_name?: string;
  email?: string;
  client_state?: string;
}

export interface NoticeBoardGetClientsResponse {
  success?: boolean;
  data?: { clients?: NoticeClientApiItem[] };
  errors?: string;
}

export interface SearchClientsPayload extends NoticeBoardSessionArgs {
  search_string: string;
  client_type?: string;
}

export interface SearchClientsResponse {
  success?: boolean;
  data?: { clients?: NoticeClientApiItem[] };
  errors?: string;
}

export interface CreateNoticePayload extends NoticeBoardSessionArgs {
  notice: string;
  subject: string;
  groups: (number | string)[];
  clients: (number | string)[];
  on_click?: string;
  is_archived?: boolean;
  notice_id?: string;
  files?: Array<{ user: string; idproof: string; doc_name: string }>;
}

export interface CreateNoticeResponse {
  success?: boolean;
  error?: string;
  errors?: string;
}

function getUserCreatedNotices(
  session: NoticeBoardSessionArgs
): Promise<GetBusinessNoticesResponse> {
  return post<GetBusinessNoticesResponse>(api.GET_USER_CREATED_NOTICES, {
    business_id: session.business_id ?? undefined,
    device_token: session.device_token,
    session_id: session.session_id,
  });
}

function getBusinessNotices(session: NoticeBoardSessionArgs): Promise<GetBusinessNoticesResponse> {
  return post<GetBusinessNoticesResponse>(api.GET_BUSINESS_NOTICES, {
    business_id: session.business_id ?? undefined,
    device_token: session.device_token,
    session_id: session.session_id,
  });
}

function getBusinessClientGroups(
  session: NoticeBoardSessionArgs
): Promise<NoticeBoardGetBusinessClientGroupsResponse> {
  return post<NoticeBoardGetBusinessClientGroupsResponse>(api.GET_BUSINESS_CLIENT_GROUPS, session);
}

export type GetNoticeBoardClientsPayload = NoticeBoardSessionArgs & {
  client_type?: string;
};

function getClients(session: GetNoticeBoardClientsPayload): Promise<NoticeBoardGetClientsResponse> {
  const { business_id, device_token, session_id, client_type = "REGISTERED" } = session;
  return post<NoticeBoardGetClientsResponse>(api.GET_CLIENTS, {
    business_id,
    device_token,
    session_id,
    client_type,
  });
}

function searchClients(payload: SearchClientsPayload): Promise<SearchClientsResponse> {
  return post<SearchClientsResponse>(api.SEARCH_CLIENTS, payload);
}

function createNotice(payload: CreateNoticePayload): Promise<CreateNoticeResponse> {
  return post<CreateNoticeResponse>(api.CREATE_NOTICE, payload);
}

export const noticeBoardService = {
  getNotices,
  getUserCreatedNotices,
  getBusinessNotices,
  getBusinessClientGroups,
  getClients,
  searchClients,
  createNotice,
};

function getNotices(session: NoticeBoardSessionArgs): Promise<GetBusinessNoticesResponse> {
  return post<GetBusinessNoticesResponse>(api.GET_NOTICES, {
    business_id: session.business_id ?? undefined,
    device_token: session.device_token,
    session_id: session.session_id,
  });
}
